// The host identifies the account domain; selection only changes the master's read view.
let hostKind = null;

export const setHostKind = (kind) => { hostKind = kind; };
export const isMasterView = () => hostKind === "master";
export const getSelectedTenant = () => isMasterView() ? sessionStorage.getItem("pos_master_tenant") || "" : "";
export const getActiveStore = () => isMasterView()
  ? sessionStorage.getItem(`pos_master_store_${getSelectedTenant()}`) || ""
  : localStorage.getItem("pos_store") || "";
export const setActiveStore = (id) => {
  if (isMasterView()) sessionStorage.setItem(`pos_master_store_${getSelectedTenant()}`, id);
  else localStorage.setItem("pos_store", id);
};
export const selectMasterTenant = (id) => {
  if (id) sessionStorage.setItem("pos_master_tenant", id);
  else sessionStorage.removeItem("pos_master_tenant");
  // Reload tears down every page's state and pending requests before loading the new scope.
  window.location.reload();
};
export const clearMasterSelection = () => {
  sessionStorage.removeItem("pos_master_tenant");
  localStorage.removeItem("pos_tenant_id"); // obsolete shared selection from the first deployment
};
